
const TerminalColor = {
  WHITE: `\x1b[1;37m`,
  RED: `\x1b[1;31m`,
  GREEN: `\x1b[1;32m`,
};
export default TerminalColor;
